import { gql } from "@apollo/client";

export const GET_REVENUE = gql`
  query GetRevenue($startDate: Date, $endDate: Date) {
    revenue(startDate: $startDate, endDate: $endDate) {
      date
      revenue
    }
  }
`;
